import SearchDriverCard from './SearchDriverCard';

export default SearchDriverCard;
